module.exports = "/images/calendar.svg?ba72a7af0e581960fe54a3bd047d060d";